import { get } from '../utils';
import { toast } from '../components';

/**
 * 购物车商品结算验证
 */
export default function updateOrderAddress(orderId: string, addressId: string, callback?: any) {
    get('order/update/address/id', {
        orderId: orderId,
        addressId: addressId,
        isRegionalShipment: '1'
    }).then((rd) => {
        if (rd.errCode == 200) {
            toast(rd.errDesc);
            callback(true, rd.errCode);
        } else {
            callback(false, rd.errCode);
            toast(rd.errDesc);
            if (rd.errCode !== 14002 || rd.errCode !== 14003) {
                history.go(-1);
            }
        }
    });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/operates/updateOrderAddress.ts